import TenantSettingsStore from "./TenantSettingsStore";

const tenantSettingsStore = new TenantSettingsStore();

export default tenantSettingsStore;
